// src/pages/Home.jsx
import React from 'react';
import Hero from '../components/ApplHero';
import Intro from '../components/ApplIntro';
import Stats from '../components/ApplCEO';
import Footer from '../components/Footer';

function AkijPrinting() {
  return (
    <>
      <Intro />
      <Hero />
      <Stats />
      <Footer />
    </>
  );
}

export default AkijPrinting;
